import { Box, Button, Icon, Text } from '@betterment/samba-react';

const InlineErrorFallback = () => {
  return (
    <Box>
      <Box
        css={{
          display: 'flex',
          gap: 'space.50',
        }}
      >
        <Icon name="ExclamationCircle" size="small" />
        <Text>Something went wrong.</Text>
        <Button variant="textPrimary" onClick={() => window.location.reload()}>
          Try again
        </Button>
      </Box>
    </Box>
  );
};

export default InlineErrorFallback;
